<!--星评 SRQ-->
<template>
  <div class="question-editor">
    <div class="question-pd">
      <div class="question-header">
        <div class="question-header-left">
          <div>
            <p class="question-number">
              {{ `${index + 1}、` }}
              <!-- <span v-if="isMust" class="asterisk">*</span> -->
            </p>
          </div>
          <div class="question-select">
            <p>评星</p>
          </div>
          <div style="display: flex; align-items: center; margin-left: 10px">
            <div class="star-select">
              <p style="font-size: 14px; margin-right: 5px">评星样式</p>
              <el-select
                v-model="starRatingLabel"
                placeholder="请选择"
                size="mini"
                @change="changeRatingStyle"
                style="
                  border: 1px solid #dcdde0;
                  border-radius: 3px;
                  width: 100px;
                "
              >
                <el-option
                  v-for="score in styleColumns"
                  :key="score.id"
                  :label="score.label"
                  :value="score.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="star-select">
              <p style="font-size: 14px; margin-right: 5px; margin-left: 5px">
                最高分
              </p>
              <el-select
                v-model="scoreNum"
                placeholder="请选择"
                size="mini"
                style="
                  border: 1px solid #dcdde0;
                  border-radius: 3px;
                  width: 100px;
                "
                @change="handleScoreChange"
              >
                <el-option
                  v-for="score in scoreColumns"
                  :key="score.id"
                  :label="score.label"
                  :value="score.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="question-header-right">
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596666801.png"
            lazy-load
            class="image-up"
            @click="handleOperateClick(2)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596715787.png"
            lazy-load
            class="image-down"
            @click="handleOperateClick(3)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596748508.png"
            lazy-load
            class="image-delete"
            @click="handleOperateClick(4)"
          />
        </div>
      </div>
      <div
        class="textarea-box"
        style="
          width: 100%;
          background: #ffffff;
          border: 1px solid #dcdde0;
          border-radius: 4px;
          padding: 12px;
          box-sizing: border-box;
          margin-top: 10px;
        "
      >
        <textarea
          placeholder-class="textarea-placeholder"
          v-model="caseProblem"
          placeholder="请给本项打分"
          maxlength="500"
          auto-height
          @input="handleInput"
          @focus="isFocusIndex = '-1'"
          @blur="state.isFocusIndex = ''"
          rows="2"
          style="width: 100%; resize: none"
        ></textarea>
        <div
          class=""
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 8px;
          "
        >
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1737857957020.png"
            mode=""
            style="width: 18px; height: 18px; cursor: pointer"
            @click="handleCaseProblemImg"
          />
          <div @click="clearQuestion" class="clear-btn">清空</div>
        </div>
      </div>
      <div class="question-images">
        <div
          v-for="(item, index) in images"
          :key="index"
          style="margin-top: 10px; position: relative"
        >
          <img :src="item" mode="widthFix" style="width: 100%" />
          <img
            src="@/assets/images/guanbi.png"
            mode="widthFix"
            class="guanbi"
            @click="handleDeleteQuestionImage(index)"
          />
        </div>
      </div>
    </div>

    <div style="width: 100%; padding: 0 25px">
      <div v-for="(item, index) in list" :key="index" class="item">
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <p style="display: block; flex-grow: 1"></p>
          <i class="el-icon-delete" @click="delItem(index)"></i>
        </div>
        <div class="option-item-bottom-input" style="border: 1px solid #dcdde0">
          <input
            placeholder-class="input-placeholder"
            type="text"
            :placeholder="'打分项' + (index + 1)"
            v-model="item.text"
            @focus="inputFocusIndex = `a${index}`"
            @blur="inputFocusIndex = ''"
          />
        </div>
        <div class="score-view">
          <div
            v-for="(val, i) in scoreNum"
            :key="i"
            v-if="starRatingStyle == 1"
          >
            <img
              src="@/assets/images/questionnaire/1_1.svg"
              alt=""
              class="stars_item"
              v-if="i <= 1"
            />
            <img
              src="@/assets/images/questionnaire/1_1.svg"
              alt=""
              class="stars_item"
              v-else
            />
          </div>
          <div
            v-for="(val, i) in scoreNum"
            :key="i"
            v-if="starRatingStyle == 2"
          >
            <img
              src="@/assets/images/questionnaire/2_1.svg"
              alt=""
              class="stars_item"
              v-if="i <= 1"
            />
            <img
              src="@/assets/images/questionnaire/2_1.svg"
              alt=""
              class="stars_item"
              v-else
            />
          </div>
          <div
            v-for="(val, i) in scoreNum"
            :key="i"
            v-if="starRatingStyle == 3"
          >
            <img
              src="@/assets/images/questionnaire/3_1.svg"
              alt=""
              class="stars_item"
              v-if="i <= 1"
            />
            <img
              src="@/assets/images/questionnaire/3_1.svg"
              alt=""
              class="stars_item"
              v-else
            />
          </div>
          <div
            v-for="(val, i) in scoreNum"
            :key="i"
            v-if="starRatingStyle == 4"
          >
            <img
              src="@/assets/images/questionnaire/4_1.svg"
              alt=""
              class="stars_item"
              v-if="i <= 1"
            />
            <img
              src="@/assets/images/questionnaire/4_1.svg"
              alt=""
              class="stars_item"
              v-else
            />
          </div>
        </div>
        <div class="rating">
          <div class="rating-item" style="border: 1px solid #dcdde0">
            <input
              placeholder-class="input-placeholder"
              type="text"
              placeholder="编辑提示词"
              v-model="item.ratingArr[0]"
            />
          </div>
          <div class="rating-item" style="border: 1px solid #dcdde0">
            <input
              placeholder-class="input-placeholder"
              type="text"
              placeholder="编辑提示词"
              v-model="item.ratingArr[1]"
            />
          </div>
          <div class="rating-item" style="border: 1px solid #dcdde0">
            <input
              placeholder-class="input-placeholder"
              type="text"
              placeholder="编辑提示词"
              v-model="item.ratingArr[2]"
            />
          </div>
        </div>
      </div>
      <div v-if="ifElseConfig" class="rating">
        <div class="rating-item" style="border: 1px solid #dcdde0">
          <input
            placeholder-class="input-placeholder"
            type="text"
            placeholder="编辑提示词"
            v-model="value1"
          />
        </div>
        <div class="rating-item" style="border: 1px solid #dcdde0">
          <input
            placeholder-class="input-placeholder"
            type="text"
            placeholder="编辑提示词"
            v-model="value2"
          />
        </div>
        <div class="rating-item" style="border: 1px solid #dcdde0">
          <input
            placeholder-class="input-placeholder"
            type="text"
            placeholder="编辑提示词"
            v-model="value3"
          />
        </div>
      </div>

      <div class="add-view" style="margin-top: 10px">
        <div class="add-batch" style="color: #ffffff">
          <el-checkbox
            label="必选题"
            v-model="isMust"
            :true-label="1"
            :false-label="0"
            class="custom-checkbox"
            @change="handleCheckboxChange"
          ></el-checkbox>
        </div>
        <div @click="addOption" class="add-btn">
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1737858857723.png"
            mode=""
            style="width: 13px; height: 13px"
          />
          <p>添加选项 {{ list.length + "/50" }}</p>
        </div>
        <div class="add-batch" style="color: #ffffff">批量添加</div>
      </div>
    </div>

    <div v-if="type === 1" class="question-footer">
      <!-- <div class="cancel-btn" @click="cancelClick">取消</div> -->
      <div class="save-btn" @click="saveClick">保存</div>
    </div>
    <input
      type="file"
      ref="fileInput"
      accept="image/*"
      style="display: none"
      @change="handleFileChange"
    />
  </div>
</template>

<script>
import PopupInput from "@/components/PopupInput/PopupInput.vue";
import axios from "axios";
import baseURL from "../../utils/bsaeUrl";

export default {
  components: {
    PopupInput,
  },
  props: {
    params: {
      type: Object,
      default: {},
    },
    index: {
      type: Number,
      default: 0,
    },
    uuid: {
      type: String,
      default: "",
    },
    type: {
      type: Number,
      default: 1, // 1 添加问卷 2 添加题库
    },
    updateType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      list: [],
      dataObj: {},
      ifRandomize: false,
      isMust: false,
      uploadIndex: 0,
      images: [],
      caseProblem: "",
      isFocusIndex: "",
      inputFocusIndex: "",
      minScore: 0,
      scoreNum: 5,
      value1: "",
      value2: "",
      value3: "",
      starRatingStyle: 4,
      starRatingLabel: "",
      styleColumns: [
        {
          id: "1",
          label: "五角星",
        },
        {
          id: "2",
          label: "爱心",
        },
        {
          id: "3",
          label: "笑脸",
        },
        {
          id: "4",
          label: "点赞",
        },
      ],
      scoreColumns: [
        {
          id: 2,
          label: "2",
        },
        {
          id: 3,
          label: "3",
        },
        {
          id: 4,
          label: "4",
        },
        {
          id: 5,
          label: "5",
        },
        {
          id: 6,
          label: "6",
        },
        {
          id: 7,
          label: "7",
        },
        {
          id: 8,
          label: "8",
        },
        {
          id: 9,
          label: "9",
        },
        {
          id: 10,
          label: "10",
        },
      ],
      ifElseConfig: false,
    };
  },
  methods: {
    handleFileChange(event) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append("file", file); // "file" 对应后端接收的字段名
      formData.append("uuid", this.uuid);
      axios
        .post(baseURL + "/PCwj/file/uploads", formData, {
          headers: {
            "Content-Type": "multipart/form-data", // 必须设置
            token: localStorage.getItem("token"),
          },
        })
        .then((response) => {
          this.$message.success("上传成功！");
          if (this.uploadIndex === -1) {
            this.images = [response.data.urls];
          } else {
            this.list[this.uploadIndex].img_path = [response.data.urls];
          }
          this.handleUpdateQuestion();
        })
        .catch((error) => {
          if (axios.isCancel(error)) {
            console.log("上传已取消:", error.message);
          } else {
            this.$message.error("上传失败！");
          }
        });
    },

    handleOperateClick(type) {
      this.$emit(
        "operate",
        JSON.stringify({
          type: type,
          index: this.index,
        })
      );
    },
    handleInput() {
      this.handleUpdateQuestion();
    },
    clearQuestion() {
      this.caseProblem = "";
      this.handleUpdateQuestion();
    },
    addOption() {
      if (this.list.length < 50) {
        this.list.push({
          id: "", //后台处理逻辑 创建时不传 唯一标识用
          text: "",
          ratingArr: ["非常不满意", "一般", "非常满意"],
          isChoose: false,
          img_path: [],
          is_fill: 0, //是否填空 0否 1是
          fill_prompt: "",
          newDate: true,
        });
        this.handleUpdateQuestion();
      } else {
        uni.showToast({
          title: "最多只能添加50个选项",
          icon: "none",
        });
      }
    },

    batchAddOptions() {
      // 批量添加选项的逻辑
      this.showpopup = true;
    },
    bitchConfirm(e) {
      // 批量添加选项的逻辑
      this.showpopup = false;
      const count = e.split("\n").filter((item) => item.trim() !== "").length;
      if (count > 50 - this.list.length) {
        uni.showToast({
          title: "最多只能添加50个选项",
          icon: "none",
        });
        return;
      }
      const list = e
        .split("\n")
        .filter((item) => item.trim() !== "")
        .map((item) => {
          return {
            id: "", //后台处理逻辑 创建时不传 唯一标识用
            text: item,
            isChoose: false,
            img_path: [],
            is_fill: 0, //是否填空 0否 1是
            fill_prompt: "",
            newDate: true,
          };
        });
      this.list = this.list.concat(list);
      this.handleUpdateQuestion();
    },
    delItem(index) {
      if (this.updateType === 1) {
        if (this.list[index].newDate) {
          this.list.splice(index, 1);
        } else {
          uni.showToast({
            title: "限制性修改状态下，不能删除之前的数据!",
            icon: "none",
          });
        }
      } else {
        this.list.splice(index, 1);
      }
      this.handleUpdateQuestion();
    },
    handleCaseProblemImg() {
      this.uploadIndex = -1;
      this.$refs.fileInput.click();
    },
    handleItemImage(index) {
      this.uploadIndex = index;
      this.$refs.fileInput.click();
    },

    handleDeleteQuestionImage(index) {
      this.images.splice(index, 1);
      this.handleUpdateQuestion();
    },
    handleDeleteItemImage(index, imgIndex) {
      this.list[index].img_path.splice(imgIndex, 1);
      this.handleUpdateQuestion();
    },
    handleScoreChange() {
      this.handleUpdateQuestion();
    },
    changeRatingStyle(e) {
      this.starRatingStyle = e;
      this.handleUpdateQuestion();
    },
    handleCheckboxChange() {
      this.isMust = !this.isMust;
      this.handleUpdateQuestion();
    },
    handleUpdateQuestion() {
      this.dataObj.isMust = this.isMust ? 1 : 0;
      this.dataObj.caseProblemImg = JSON.stringify(this.images);
      this.dataObj.ifRandomize = this.ifRandomize ? 1 : 0;
      this.dataObj.caseProblem = this.caseProblem;
      this.dataObj.chooseList = JSON.stringify({
        list: this.list.map((item, index) => {
          item.is_fill = item.is_fill ? 1 : 0;
          return item;
        }),
      });
      this.dataObj.starRatingStyle = this.starRatingStyle;
      this.dataObj.scoreNum = this.scoreNum;
      // this.dataObj.elseConfig = JSON.stringify([
      //   this.value1,
      //   this.value2,
      //   this.value3,
      // ]);
      this.$emit(
        "update",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        })
      );
    },
    cancelClick() {
      this.$emit(
        "cancel",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        })
      );
    },
    saveClick() {
      if (this.caseProblem.includes(" ") && this.caseProblem.trim() === "") {
        uni.showToast({
          title: "请输入题目",
          icon: "none",
        });
      }

      this.dataObj.isMust = this.isMust ? 1 : 0;
      this.dataObj.caseProblemImg = JSON.stringify(this.images);
      this.dataObj.ifRandomize = this.ifRandomize ? 1 : 0;
      this.dataObj.caseProblem =
        this.caseProblem === "" ? "请给本项打分" : this.caseProblem;
      this.dataObj.chooseList = JSON.stringify({
        list: this.list.map((item, index) => {
          item.is_fill = item.is_fill ? 1 : 0;
          item.text = item.text === "" ? `打分项${index + 1}` : item.text;
          return item;
        }),
      });
      this.dataObj.starRatingStyle = this.starRatingStyle;
      this.dataObj.scoreNum = this.scoreNum;
      // this.dataObj.elseConfig = JSON.stringify([
      //   this.value1,
      //   this.value2,
      //   this.value3,
      // ]);
      this.$emit(
        "save",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        })
      );
    },
    handleClick() {},
  },
  watch: {
    params: {
      handler(newVal, oldVal) {
        console.log("dataObj 变化了", newVal, oldVal);
        this.dataObj = newVal;
        this.caseProblem = newVal.caseProblem;
        this.list = JSON.parse(newVal.chooseList).list.map((item) => {
          item.is_fill = item.is_fill === 1;
          return item;
        });
        this.ifRandomize = newVal.ifRandomize === 1;
        this.isMust = newVal.isMust === 1;
        this.images = JSON.parse(newVal.caseProblemImg);
        this.scoreNum = newVal.scoreNum;
        this.starRatingStyle = newVal.starRatingStyle;
        this.starRatingLabel = this.styleColumns.find(
          (item) => item.id === newVal.starRatingStyle
        ).label;
        if (newVal.data.elseConfig) {
          this.ifElseConfig = true;
          this.value1 = JSON.parse(newVal.data.elseConfig)[0];
          this.value2 = JSON.parse(newVal.data.elseConfig)[1];
          this.value3 = JSON.parse(newVal.data.elseConfig)[2];
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
button {
  margin-left: 10px;
}

.add-view {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.add-batch {
  height: 20px;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #509dee;
  line-height: 20px;
  cursor: pointer;
}

.minus {
  width: 19px;
  height: 19px;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.input {
  padding: 0 10px;
  background: #ffffff;
}

.plus {
  width: 19px;
  height: 19px;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.question-header-left {
  display: flex;
  align-items: center;
}

.question-header-right {
  display: flex;
  align-items: center;
}

.option-item-top-right input {
  color: #4c4a56;
}
.textarea-box textarea {
  color: #4c4a56;
}

::v-deep(.u-checkbox__label-wrap) {
  white-space: nowrap;
  writing-mode: horizontal-tb;
}

.item {
  width: 100%;
  background: #f8f8f8;
  border: 1px dashed #3a60ff;
  border-radius: 4px;
  padding: 10px 25px;
  box-sizing: border-box;
  margin-top: 10px;
}

.item text {
  font-size: 14px;
  font-weight: 400;
  color: #2b2f36;
  margin-bottom: 10px;
}

.rating {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}

.rating-item {
  width: 170px;
  height: 33px;
  background: #ffffff;
  border: 1px solid #ededed;
  border-radius: 3px;
  display: flex;
  align-items: center;
  padding: 0 13px;
  box-sizing: border-box;
}

.rating-item input {
  width: 100%;
  height: 100%;
  border: none;
  box-sizing: border-box;
  font-size: 13px;
  text-align: center;
}

.question-header-right {
  display: flex;
  align-items: center;
}

.score-view {
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
}

.score-view-item-active {
  width: 29px;
  height: 29px;
  line-height: 29px;
  background-color: #4a73f8;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  border-radius: 15px;
}

.score-view-item-inactive {
  width: 27px;
  height: 27px;
  line-height: 27px;
  border: 1px solid #ededed;
  background-color: #f9f9f9;
  color: #2b2f36;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  border-radius: 15px;
}

.star-select {
  display: flex;
  align-items: center;

  p {
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionEdit/QuestionEditSRQ.vue